import DataViewer from '@/components/DataViewer';
import React, { useState } from 'react';

const DataViewerOutput = ({ obj = {}, singleton, expanded = false, forceTruncated, search }) => {
  const [truncated, setTruncated] = useState(forceTruncated || (Object.keys(obj || {}).length > 12 && !singleton && expanded !== true));

  return (
    <div className={`data-viewer-container ${truncated ? 'truncated' : ''}`}>
      <DataViewer data={obj} search={search} />
      {truncated && (
        <div className={'expander'} onClick={() => setTruncated(false)}>
          Expand
        </div>
      )}
    </div>
  );
};

export default DataViewerOutput;
